<template>
    <div class="landing-page-wrapper home page-template page-template-elementor_header_footer page page-id-9 wp-custom-logo wp-embed-responsive elementor-default elementor-template-full-width elementor-kit-687 elementor-page elementor-page-9"
        data-link="type-2" data-prefix="single_page" data-header="type-1:sticky" data-footer="type-1"
        itemscope="itemscope" itemtype="https://schema.org/WebPage">

        <!-- SVG Sprite -->
        <div style="display: none;">
            <object data="/assets/svg/sprite.svg" type="image/svg+xml"
                style="position: absolute; width: 0; height: 0;"></object>
        </div>

        <!-- Skip Link -->
        <a class="skip-link show-on-focus" href="#main">
            Skip to content</a>

        <!-- Mobile Menu -->
        <div class="ct-drawer-canvas" data-location="start">
            <!-- Mobile Menu -->
            <div id="offcanvas" class="ct-panel ct-header" data-behaviour="right-side">
                <div class="ct-panel-inner">
                    <div class="ct-panel-actions">
                        <button class="ct-toggle-close" data-type="type-1" aria-label="Close drawer">
                            <svg width="12" height="12" class="ct-icon">
                                <use href="/assets/svg/sprite.svg#ct_icon_2"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="ct-panel-content" data-device="desktop">
                        <div class="ct-panel-content-inner"></div>
                    </div>
                    <div class="ct-panel-content" data-device="mobile">
                        <div class="ct-panel-content-inner">
                            <nav class="mobile-menu" data-id="mobile-menu" data-interaction="click"
                                data-toggle-type="type-1" aria-label="Off Canvas Menu">
                                <ul id="menu-all-menu" role="menubar">
                                    <li id="menu-item-824"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-9 current_page_item menu-item-824"
                                        role="none"><a href="https://socrateslegacy.com/" aria-current="page"
                                            class="ct-menu-link" role="menuitem">Home</a></li>
                                    <li id="menu-item-829"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-829"
                                        role="none"><a href="https://socrateslegacy.com/account/" class="ct-menu-link"
                                            role="menuitem">Account</a></li>
                                    <li id="menu-item-827"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-827"
                                        role="none"><a href="https://socrateslegacy.com/about/" class="ct-menu-link"
                                            role="menuitem">About</a></li>
                                    <li id="menu-item-828"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-828"
                                        role="none"><a href="https://socrateslegacy.com/contact-us/"
                                            class="ct-menu-link" role="menuitem">Contact Us</a></li>
                                </ul>
                            </nav>

                            <div class="ct-header-text " data-id="text">
                                <div class="entry-content">
                                    <p><strong>Address<br /></strong>Hamchaku, Mustsamuda, Atonomes Island of Anjouan
                                        Union of Comoros.
                                    </p>
                                    <p><strong>Work Hours<br /></strong>Monday to Friday: 7AM -
                                        7PM<strong><br /></strong></p>
                                </div>
                            </div>

                            <div class="ct-header-socials " data-id="socials">
                                <div class="ct-social-box" data-color="custom" data-icon-size="custom"
                                    data-icons-type="simple">
                                    <a href="#" data-network="facebook" aria-label="Facebook" rel="noopener">
                                        <span class="ct-icon-container">
                                            <svg width="20px" height="20px" aria-hidden="true">
                                                <use href="/assets/svg/sprite.svg#icon_20x20"></use>
                                            </svg>
                                        </span> </a>
                                    <a href="#" data-network="twitter" aria-label="X (Twitter)" rel="noopener">
                                        <span class="ct-icon-container">
                                            <svg width="20px" height="20px" aria-hidden="true">
                                                <use href="/assets/svg/sprite.svg#icon_20x20_1"></use>
                                            </svg>
                                        </span> </a>
                                    <a href="#" data-network="instagram" aria-label="Instagram" rel="noopener">
                                        <span class="ct-icon-container">
                                            <svg width="20" height="20" aria-hidden="true">
                                                <use href="/assets/svg/sprite.svg#icon_20x20_2"></use>
                                            </svg>
                                        </span> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Container -->
        <div id="main-container">
            <!-- Header -->
            <LandingHeader />

            <!-- Main Content -->
            <main id="main" class="site-main hfeed">
                <div data-elementor-type="wp-page" data-elementor-id="9" class="elementor elementor-9">
                    <!-- Hero Section -->
                    <ContactHero />

                    <HorizontalContact :activeTab="activeTab" @update:activeTab="handleTabChange" />

                    <!-- Tab Content with Transition -->
                    <div class="tab-content-wrapper">
                        <transition name="fade" mode="out-in">
                            <!-- About Tab Content -->
                            <div v-if="activeTab === 'contact-us'" key="contact-us">
                                <AddressSection />
                            </div>

                            <!-- Roadmap Tab Content -->
                            <div v-else-if="activeTab === 'faq'" key="faq">
                                <FAQSection />
                            </div>
                        </transition>
                    </div>

                    <!-- Call to Action -->
                    <LandingCallToAction />
                </div>
            </main>

            <!-- Footer -->
            <LandingFooter />
        </div>

    </div>
</template>

<script>
import LandingHeader from './shared/Header.vue'
import LandingFooter from './shared/Footer.vue'
import RegulationSection from './about/RegulationSection.vue'
import LandingCallToAction from './shared/CallToAction.vue'
import ContactHero from './contact/ContactHero.vue'
import HorizontalContact from './contact/HorizontalContact.vue'
import AddressSection from './contact/AddressSection.vue'
import FAQSection from './contact/FAQSection.vue'

export default {
    name: 'LandingPage',
    components: {
        LandingHeader,
        ContactHero,
        HorizontalContact,
        AddressSection,
        FAQSection,
        RegulationSection,
        LandingCallToAction,
        LandingFooter
    },
    data() {
        return {
            activeTab: 'contact-us'
        }
    },
    methods: {
        handleTabChange(newTab) {
            this.activeTab = newTab;
            // Smooth scroll to content
            this.$nextTick(() => {
                const tabContent = document.querySelector('.tab-content-wrapper');
                if (tabContent) {
                    const yOffset = -80; // Offset for fixed header if any
                    const y = tabContent.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            });
        }
    },
    mounted() {
        // Add CSS links to head
        const cssFiles = [
            { href: '/wp-content/uploads/blocksy/css/global.css?ver=03668', id: 'blocksy-dynamic-global-css' },
            { href: '/wp-content/plugins/formidable/css/formidableforms.css?ver=3271424', id: 'formidable-css' },
            { href: '/wp-includes/css/dist/block-library/style.min.css?ver=6.4.5', id: 'wp-block-library-css' },
            { href: '/wp-content/plugins/table-addons-for-elementor/public/css/table-addons-for-elementor-public.css?ver=1.4.0', id: 'table-addons-for-elementor-public-css' },
            { href: '/wp-content/themes/blocksy/style.css?ver=6.4.5', id: 'blocksy-style-css' },
            { href: '/wp-content/plugins/elementor/assets/css/frontend-lite.min.css?ver=3.19.1', id: 'elementor-frontend-css' },
            { href: '/wp-content/plugins/elementor/assets/lib/swiper/v8/css/swiper.min.css?ver=8.4.5', id: 'elementor-swiper-css' },
            { href: '/wp-content/uploads/elementor/css/post-687.css?ver=1707234581', id: 'elementor-post-687-css' },
            { href: '/wp-content/uploads/elementor/css/post-9.css?ver=1707746434', id: 'elementor-post-9-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/main.min.css?ver=2.0.23', id: 'blocksy-main-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/forminator.min.css?ver=2.0.23', id: 'forminator-module-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/elementor-frontend.min.css?ver=2.0.23', id: 'blocksy-elementor-frontend-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/wpforms.min.css?ver=2.0.23', id: 'wpforms-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/no-scripts.min.css', id: 'ct-no-scripts-css' },
            { href: '/wp-content/plugins/wordpress-popup/assets/hustle-ui/css/hustle-icons.min.css?ver=7.8.3', id: 'hustle_icons-css' },
            { href: '/wp-content/plugins/wordpress-popup/assets/hustle-ui/css/hustle-global.min.css?ver=7.8.3', id: 'hustle_global-css' },
            { href: '/wp-content/plugins/wordpress-popup/assets/hustle-ui/css/hustle-info.min.css?ver=7.8.3', id: 'hustle_info-css' },
            { href: '/wp-content/plugins/wordpress-popup/assets/hustle-ui/css/hustle-popup.min.css?ver=7.8.3', id: 'hustle_popup-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/non-critical-styles.min.css?ver=2.0.23', id: 'ct-main-non-critical-styles-css' },
            { href: '/wp-content/themes/blocksy/static/bundle/page-title.min.css?ver=2.0.23', id: 'blocksy-page-title-css' },
            { href: '/wp-content/plugins/elementor/assets/css/widget-icon-list.min.css?ver=3.19.1', id: 'widget-icon-list-css' },
            { href: '/assets/css/inline_style_1.css', id: 'account-main-css' },
            { href: '/assets/css/inline_style_3.css', id: 'account-elementor-css' },
            { href: '/assets/css/inline_style_4.css', id: 'account-style-4-css' },
            { href: '/assets/css/inline_style_5.css', id: 'account-style-5-css' },
            { href: '/assets/css/inline_style_6.css', id: 'account-style-6-css' },
            { href: '/assets/css/inline_style_7.css', id: 'account-style-7-css' },
            { href: '/assets/css/inline_style_8.css', id: 'account-style-8-css' },
            { href: '/assets/css/inline_style_9.css', id: 'account-style-9-css' },
            { href: '/assets/css/inline_style_10.css', id: 'account-style-10-css' },
            { href: '/assets/css/inline_style_11.css', id: 'account-style-11-css' },
            { href: '/assets/css/inline_style_12.css', id: 'account-style-12-css' }
        ];

        // Add CSS files
        cssFiles.forEach(({ href, id }) => {
            if (!document.getElementById(id)) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.id = id;
                link.href = href;
                link.media = 'all';
                document.head.appendChild(link);
            }
        });

        // Add Google Fonts
        const fontLinks = [
            'https://fonts.googleapis.com/css2?family=DM%20Sans:wght@400;600&display=swap',
            'https://fonts.googleapis.com/css?family=Roboto%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CRoboto+Slab%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CFira+Sans%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CDM+Sans%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CRoboto+Mono%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic&display=auto&ver=6.4.5'
        ];

        fontLinks.forEach(href => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
        });
    }
}
</script>

<style>
/* Reset body margin */
body {
    margin: 0;
    padding: 0;
}

/* Global styles from WordPress theme */
.landing-page-wrapper {
    --wp--preset--color--black: #000000;
    --wp--preset--color--cyan-bluish-gray: #abb8c3;
    --wp--preset--color--white: #ffffff;
    --wp--preset--color--pale-pink: #f78da7;
    --wp--preset--color--vivid-red: #cf2e2e;
    --wp--preset--color--luminous-vivid-orange: #ff6900;
    --wp--preset--color--luminous-vivid-amber: #fcb900;
    --wp--preset--color--light-green-cyan: #7bdcb5;
    --wp--preset--color--vivid-green-cyan: #00d084;
    --wp--preset--color--pale-cyan-blue: #8ed1fc;
    --wp--preset--color--vivid-cyan-blue: #0693e3;
    --wp--preset--color--vivid-purple: #9b51e0;
    --wp--preset--color--palette-color-1: var(--theme-palette-color-1, #aa8811);
    --wp--preset--color--palette-color-2: var(--theme-palette-color-2, #3a2a00);
    --wp--preset--color--palette-color-3: var(--theme-palette-color-3, #1a2128);
    --wp--preset--color--palette-color-4: var(--theme-palette-color-4, #727272);
    --wp--preset--color--palette-color-5: var(--theme-palette-color-5, #fff9ef);
    --wp--preset--color--palette-color-6: var(--theme-palette-color-6, #F3F5F7);
    --wp--preset--color--palette-color-7: var(--theme-palette-color-7, #fffcf7);
    --wp--preset--color--palette-color-8: var(--theme-palette-color-8, #ffffff);
    --wp--style--global--content-size: var(--theme-block-max-width);
    --wp--style--global--wide-size: var(--theme-block-wide-max-width);
    --wp--style--block-gap: var(--theme-content-spacing);
    width: 100%;
    min-height: 100vh;
    margin: 0;
    padding: 0;
}

/* WordPress block styles */
.wp-site-blocks>.alignleft {
    float: left;
    margin-right: 2em;
}

.wp-site-blocks>.alignright {
    float: right;
    margin-left: 2em;
}

.wp-site-blocks>.aligncenter {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
}

/* Elementor container styles */
.e-con-inner {
    display: flex;
    flex-direction: column;
}

/* Ensure images and content display properly */
img {
    max-width: 100%;
    height: auto;
}

/* Tab content wrapper */
.tab-content-wrapper {
    min-height: 400px;
    position: relative;
}

/* Tab content transition */
.fade-enter-active {
    transition: all 0.4s ease;
}

.fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* Smooth scroll behavior */
html {
    scroll-behavior: smooth;
}
</style>